<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <TwButton class="menu_button" type="secondary" size="small" icon="menu" >
      {{ label }}
      <!-- <i class="el-icon-arrow-down el-icon--right" /> -->
    </TwButton>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in items"
        :key="item.value"
        :command="item.value"
        :disabled="item.disabled"
        :data-gtm="item.gtm"
      >
        <i :class="item.icon" v-if="item.icon" style="margin-right: 5px" />
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import TwButton from '@/components/atoms/TwButton';

export default defineComponent({
  name: 'MenuButton',
  components: {
    TwButton,
  },
  props: {
    label: {
      type: String,
      default: 'Menu',
    },
    items: {
      type: Array,
      required: true, // [{ label: '編集', value: 'edit', icon: 'el-icon-edit' }]
    },
  },
  setup(_, { emit }) {
    const handleCommand = (command) => {
      emit('select', command);
    };
    return {
      handleCommand,
    };
  },
});
</script>
